import {useHistory} from 'react-router-dom';

export default function useQuickRouter() {
  const history = useHistory();
  return {
    index: () => history.push('/'),
    login: () => history.push('/user/login'),
    register: () => history.push('/user/register'),
    userProfile: () => history.push('/user/profile'),
    manageUserList: () => history.push('/manage/user/list'),
    manageSystem: () => history.push('/manage/system'),
    contestDetail: (id: number) => history.push('/contest/' + id),
    manageKnowledgeBankList: () => history.push('/manage/knowledgeBank/list'),
    manageKnowledgeBankNew: () => history.push('/manage/knowledgeBank/new'),
    manageKnowledgeBankEdit: (id: number) => history.push('/manage/knowledgeBank/edit/' + id),
    manageContestList: () => history.push('/manage/contest/list'),
    manageContestNew: () => history.push('/manage/contest/new'),
    manageContestEdit: (id: number) => history.push('/manage/contest/edit/' + id),
    manageContestNoticeList: (contestId: number) => history.push('/manage/contestNotice/list/' + contestId),
    manageContestNoticeNew: (contestId: number) => history.push('/manage/contestNotice/new/' + contestId),
    manageContestNoticeEdit: (contestId: number, id: number) => history.push('/manage/contestNotice/edit/' + contestId + '/' + id),
    manageKnowledgeTestExportReport: (id: number) => history.push('/manage/knowledgeTest/exportReport/' + id),
    knowledgeTestDetail: (id: number) => history.push('/knowledgeTest/' + id),
    knowledgeTestHistory: (id: number, userId: number) => history.push('/knowledgeTest/' + id + '/history/' + userId),
    knowledgeTestResult: (id: number, userId: number) => history.push('/knowledgeTest/' + id + '/result/' + userId),
    collectionWorkUploadRecord: (id: number) => history.push('/collectionWork/' + id + '/uploadRecord'),
    collectionWorkMyRecords: (id: number) => history.push('/collectionWork/' + id + '/myRecords'),
    collectionWorkReview: (id: number) => history.push('/collectionWork/' + id + '/review'),
    contestNoticeDetail: (id: number) => history.push('/contestNotice/' + id),
    knowledgeSubmissionSubmit: (id: number) => history.push('/knowledgeSubmission/' + id + '/submit'),
    knowledgeSubmissionResult: (id: number) => history.push('/knowledgeSubmission/' + id + '/result'),
  };
}
